import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUsersByClient } from '../redux/actions/clients';
import { StoreState } from '../types/state';

const useClientUsers = (id: string) => {
  const users = useSelector((state: StoreState) => {
    return state.clients.clientUsers[id];
  });
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!users) {
      setIsLoading(true);
      dispatch(getUsersByClient(id));
    } else {
      setIsLoading(false);
    }
  }, [users, dispatch, id]);
  return { users, isLoading };
};

export default useClientUsers;
